import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { LayoutDashboard } from '../layouts/layout-dashboard';
import { useAxios } from './../hooks/useAxios';
import { Console } from './../services/platform-api';

const DocumentExtractComponent = () => {
  const [dataResponse, setDataResponse] = useState();
  const { id } = useParams();
  const [selectedFile, setSelectedFile] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [checkStatus, setCheckStatus] = useState(false);
  const [jobReady, setJobReady] = useState(false);
  const [uploadResp, setUploadResp] = useState({});
  const { data, error, loading, fetchNow } = useAxios();

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // On file upload (click the upload button)
  const onFileUpload = () => {
    setDataResponse([]);
    setJobId(null);

    let payload = {
      name: selectedFile.name,
      file: selectedFile,
      country: 'UA',
      workflow: id,
    };

    /**
     * URL    * Request method, POST- GET     * Payload     * isfile - boolean
     */
    fetchNow(`/api/platform/uploadworkflowfile`, 'POST', payload, true);
  };

  const grabData = () => {
    const payload = {
      timeout: 5,
      key: uploadResp.key,
      bucket: uploadResp.bucket,
    };
    fetchNow(`/api/document-extraction/extract`, 'POST', payload);
    setSelectedFile(null);
  };

  useEffect(() => {
    if (loading) return;
    if (error || data?.code === 500) {
      Console('error ', error, 'log');
      setJobReady(false);
      return;
    }

    if (data?.bucket) {
      // catch the upload response
      setUploadResp(data);
    } else if (data?.Fields) {
      // we have the document extracted
      setDataResponse(data);
      setJobReady(false);
    } else if (data?.Job_ID !== null && data?.Job_ID !== undefined) {
      // hold the job Id and start a check timer
      setJobId(data?.Job_ID);
      setCheckStatus(true);
    }
  }, [data, loading, error]);

  /**
   * This is the check status logic
   * It will hit the api in the timeout loop until we have a succeed result as above
   */
  useEffect(() => {
    let interval = null;
    if (loading || !checkStatus || jobReady) return;
    if (jobId) {
      interval = setInterval(() => {
        // check job loop
        const payload = {
          jobId: jobId,
        };
        fetchNow(`/api/document-extraction/status`, 'POST', payload);
      }, 7000);

      if (data?.Status === 'SUCCEEDED') {
        setJobReady(true);
        setCheckStatus(false);
        return () => clearInterval(interval);
      }
    }
    return () => clearInterval(interval);
  }, [checkStatus, fetchNow, jobId, loading, jobReady, data]);

  useEffect(() => {
    if (loading || !jobReady || checkStatus || !jobId) return;

    if (!data?.Fields) {
      const body = {
        jobId: jobId,
      };
      fetchNow(`/api/document-extraction/complete`, 'POST', body, false);
      setJobReady(false);
    }
  }, [jobReady, uploadResp, fetchNow, jobId, loading, data?.Fields, checkStatus]);

  return (
    <>
      <Container fluid>
        <Row>
          <Col lg={12} className="p-5">
            <div className="wrapper">
              <div>
                <input type="file" onChange={onFileChange} />
                <button onClick={onFileUpload}>Upload Document</button>
              </div>

              <Button onClick={grabData}>Process Document</Button>
              {loading ? 'Loading...' : null}
            </div>
          </Col>
        </Row>
        <LayoutDashboard>
          {error ? <h3>{data?.message}</h3> : null}
          {
            //  <h3>PROCESSING...</h3>
            //  ) : (
            dataResponse?.Fields?.map((obj, key) => {
              // replace _ with space and uppercase first letter words
              let label_str = obj.label.replaceAll('_', ' ');
              const arr = label_str.split(' ');
              for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
              }
              const formattedLabel = arr.join(' ');

              return (
                <p key={key}>
                  <strong>{formattedLabel}</strong> : {obj.result}
                </p>
              );
            })
          }
        </LayoutDashboard>
      </Container>
    </>
  );
};

export { DocumentExtractComponent };
